export default __webpack_public_path__ + "static/media/LoginImage.102e7bab.png";